<template>
    <div class="majorStructure">
        <div class="close"@click="componentCancel"></div>
        <img src="@/assets/imgs/Kingdoms/component/bg.png"  alt="">
        <div class="content">
            <div class="tit">
                <img :src="require(`@/assets/imgs/Kingdoms/component/tit${type}.png`)" alt="">
            </div>
            <!-- 详细信息 -->
            <!-- 兑换 -->
            <div class="detailedInformation" v-if="type == 1">
                <!-- 兑换提示 -->
                <p class="hint">壮行酒不足，需要使用1个金龙元宝兑换1个壮行酒？</p>
                <p class="hint" v-if="nextDrawCost">本次抽奖需<span>{{ nextDrawCost }}</span>个壮行酒</p>
                <!-- 兑换图展示 -->
                <div class="conversion_img">
                    <img src="@/assets/imgs/Kingdoms/component/coin.png" alt="">
                    <p>1:1</p>
                    <img src="@/assets/imgs/Kingdoms/component/conversion_coin.png" alt="">
                </div>
                <!-- 兑换 -->
                <div class="conversion_input">
                    <span>兑换 :</span>
                    <input type="text" v-model="conversion_number">
                </div>
                <div class="ConfirmExchange">
                    <img @click="componentCancel" src="@/assets/imgs/Kingdoms/component/cancel.png" alt="">
                    <img @click="componentConfirm" src="@/assets/imgs/Kingdoms/component/conversion.png" alt="">
                </div>
            </div>
            <!-- 兑换提示 -->
            <div class="detailedInformation" v-if="type == 2">
                <p class="hint exchange_hint">确定消费{{ nextDrawCost }}个壮行酒抽取你的宝箱嘛？</p>
                <div class="ConfirmExchange">
                    <img @click="componentCancel" src="@/assets/imgs/Kingdoms/component/cancel.png" alt="">
                    <img @click="componentConfirm" src="@/assets/imgs/Kingdoms/component/confirm.png" alt="">
                </div>
            </div>
            <!-- 规则说明 -->
            <div class="detailedInformation" v-if="type == 3">
                <div class="rules">
                    <div class="itm" style="text-align: center;"><span>活动时间：</span><span
                            style="color: red;font-weight: 700;">2025年12月2日—2025年12月21日24点</span></div>
                    <div class="itm"><span>活动细则：</span></div>
                    <div class="itm tindent">1.一个金龙元宝可以兑换一个壮行酒。</div>
                    <div class="itm tindent">2.活动结束后，未曾使用的壮行酒将失效，请于活动截止前及时使用。</div>
                    <div class="itm tindent">3.消耗壮行酒可打开军械箱并获得对应奖励，活动奖励请于网站商城—个人仓库查收。</div>
                    <div class="itm tindent">4.每次打开军械箱获得的奖励不会重复，累计打开10个军械箱可获得所有全部奖励。</div>
                    <div class="itm tindent">5.每次打开军械箱所消耗的壮行酒会随着轮次依次递增。</div>
                    <div class="itm tindent">6.本次活动奖池不可重置，本次活动奖池道具均为绑定。</div>
                    <div class="itm tindent">7.用户获得本次活动奖池中所有奖励可激活翼德集市。</div>
                    <div class="itm tindent">8.打开军械箱消耗明细如下：</div>
                    <div class="itm tindent">
                        <table>
                            <thead>
                                <tr>
                                    <th>轮数</th>
                                    <th>消耗壮行酒</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>6</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>18</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>36</td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>52</td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>99</td>
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>158</td>
                                </tr>
                                <tr>
                                    <td>7</td>
                                    <td>238</td>
                                </tr>
                                <tr>
                                    <td>8</td>
                                    <td>328</td>
                                </tr>
                                <tr>
                                    <td>9</td>
                                    <td>418</td>
                                </tr>
                                <tr>
                                    <td>10</td>
                                    <td>508</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="itm tindent">10.初始概率公示：</div>
                    <div class="itm tindent">
                        <table>
                            <thead>
                                <tr>
                                    <th>初始概率</th>
                                    <th>道具</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>0.05%</td>
                                    <td>我乃燕人张翼德（绑定）</td>
                                </tr>
                                <tr>
                                    <td>0.95%</td>
                                    <td>2025年1期新宠福袋(绑定)</td>
                                </tr>
                                <tr>
                                    <td>2%</td>
                                    <td>万夫莫敌（绑定）</td>
                                </tr>
                                <tr>
                                    <td>4%</td>
                                    <td>一大袋源土(绑定)</td>
                                </tr>
                                <tr>
                                    <td>8%</td>
                                    <td>月卡礼包(绑定)</td>
                                </tr>
                                <tr>
                                    <td>9%</td>
                                    <td>一袋源土(绑定)x3</td>
                                </tr>
                                <tr>
                                    <td>11%</td>
                                    <td>欧皇纯化源土礼包(绑定)</td>
                                </tr>
                                <tr>
                                    <td>15%</td>
                                    <td>咕咕霍夫蛋糕(绑定)</td>
                                </tr>
                                <tr>
                                    <td>20%</td>
                                    <td>六倍经验果(1小时)(绑定)x10</td>
                                </tr>
                                <tr>
                                    <td>30%</td>
                                    <td>苏舶大鹅汤的材料袋(绑定)x2</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="ConfirmExchange" style="margin-top: 15px;">
                    <img @click="componentCancel" src="@/assets/imgs/Kingdoms/component/cancel.png" alt="">
                </div>
            </div>
            <!-- 奖池预览 -->
            <div class="detailedInformation" v-if="type == 4">
                <div class="preview">
                    <div :class="[{ 'yetitem': getList.includes(item.itemId) }, 'it']"
                        v-for="(item, index) in TarotData.allPrizes" :key="item.itemId">
                        <!-- <img src="https://bpic.588ku.com/element_origin_min_pic/23/07/11/d32dabe266d10da8b21bd640a2e9b611.jpg!r650"
                            alt=""> -->
                        <el-tooltip class="item" effect="dark" :content="item.itemDesc" placement="top">
                            <img :src="item.itemImg" alt="" title="点击显示详情">
                        </el-tooltip>
                        <!-- </el-tooltip> -->

                        <p>{{ item.itemName }}X{{ item.itemNum }}</p>
                        <span>已获取</span>
                    </div>
                </div>
                <div class="ConfirmExchange" style="margin-top: 15px;">
                    <img @click="componentCancel" src="@/assets/imgs/Kingdoms/component/cancel.png" alt="">
                </div>
            </div>
            <!-- 元宝不足 -->
            <div class="detailedInformation" v-if="type == 5">
                <p class="hint exchange_hint">金龙元宝不足，确定要去充值嘛？</p>
                <div class="ConfirmExchange">
                    <img @click="componentCancel" src="@/assets/imgs/Kingdoms/component/cancel.png" alt="">
                    <img @click="componentConfirm" src="@/assets/imgs/Kingdoms/component/confirm.png" alt="">
                </div>
            </div>
            <!-- 隐藏兑换-->
            <div class="detailedInformation" v-if="type == 6">
                <p class="hint exchange_hint">确定使用{{ nextDrawCost }}壮行酒兑换吗？</p>
                <div class="ConfirmExchange">
                    <img @click="componentCancel" src="@/assets/imgs/Kingdoms/component/cancel.png" alt="">
                    <img @click="componentConfirm" src="@/assets/imgs/Kingdoms/component/confirm.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        close: {
            type: Function,
            required: true // 或根据需要设置为 false
        },
        Confirm: {
            type: Function,
            required: true
        },
        type: { type: Number, required: true, default: 1 },
        TarotIndex: { type: Number, required: false },
        nextDrawCost: { required: false },
        TarotData: { required: false }
    },
    data() {
        return {
            conversion_number: 1,
            getList: [],
        }
    },
    created() {

    },
    mounted() {
        if (this.TarotData) {
            this.getList = this.TarotData.drawHistory.map((item) => {
                return item.itemId
            })
        }
        // console.log(this.getList);

    },
    methods: {
        //关闭
        componentCancel() {
            this.close()
        },
        // 确定
        componentConfirm() {
            this.Confirm({
                type: this.type,
                conversion_number: this.conversion_number,
                TarotIndex: this.TarotIndex
            })
        }
    }
}

</script>

<style lang="less" scoped>
.majorStructure {
    position: relative;

    .close {
        position: absolute;
        right: 75px;
        top: 40px;
        width: 50px;
        height: 50px;
        cursor: pointer;
    }

    .content {
        width: 80%;
        position: absolute;
        top: 55px;
        left: 53%;
        transform: translateX(-50%);

        .tit {
            width: 100%;
            text-align: center;
            // margin-bottom: 30px;
        }

        .detailedInformation {
            width: 95%;
            margin: auto;

            // start  兑换 
            .hint {
                font-size: 25px;
                text-align: center;
                color: #fff;
                line-height: 40px;

                span {
                    color: red;
                    font-size: 25px;
                    text-align: center;
                }
            }

            .conversion_img {
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 20px 0;

                >img {
                    // width: 100px;
                    max-height: 80px;
                }

                >p {
                    font-size: 50px;
                    font-weight: 600;
                    margin: 0 50px;
                    color: #d2d07b;
                    font-family: Verdana, Geneva, Tahoma, sans-serif;
                }
            }

            .conversion_input {
                display: flex;
                align-items: center;
                justify-content: center;

                span {
                    font-size: 24px;
                    margin-right: 30px;
                    color: #fff;
                    font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;

                }

                input {
                    line-height: 40px;
                    border-radius: 20px;
                    text-align: center;
                    font-size: 20px;
                    background-color: #c6492e;
                    color: #fff;
                    border: 1px solid #fff;
                }

                input:focus {
                    outline: 2px solid #fce18d;
                    border: 1px solid #fce18d;

                    /* 获得焦点时显示绿色轮廓 */
                }
            }

            .ConfirmExchange {
                margin: 30px 0;
                text-align: center;

                >img {
                    margin: 0 20px;
                }
            }

            // end
            // start  兑换提示
            .exchange_hint {
                // margin-top: 100px;
                line-height: 200px;
            }

            // end
            // start  规则说明 
            // 说明
            .rules {
                padding: 20px;
                max-height: 240px;
                overflow-y: scroll;
                overflow-x: hidden;

                .itm {
                    line-height: 30px;
                    color: #c4462c;
                    font-size: 18px;

                    span {
                        font-size: 20px;
                    }

                    table {
                        width: 500px;
                        border-collapse: collapse;
                        margin: 20px auto;
                    }

                    table,
                    th,
                    td {
                        border: 1px solid #000;
                    }

                    th,
                    td {
                        text-align: center;
                        padding: 8px;
                    }
                }

                .tindent {
                    text-indent: 1em
                }

            }

            // end
            // start  奖池预览 
            .preview {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                // margin-top: 50px;

                .it {
                    width: 19%;
                    // height: 150px;
                    text-align: center;
                    padding: 10px 0;
                    border: 1px solid #fbe251;
                    margin-bottom: 10px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-direction: column;

                    img {
                        // width: 100px;
                        max-height: 100px;
                    }

                    p {
                        margin-top: 10px;
                        color: #fff;
                        font-size: 15px;
                    }

                    span {
                        display: none;
                    }
                }

                .yetitem {
                    position: relative;
                    filter: grayscale(100%);

                    p {
                        color: #00ffea;
                    }

                    span {
                        display: inline-block;
                    }

                }

                .yetitem::after {
                    content: '';
                    /* 伪元素必须有content属性 */
                    /* 绝对定位使图片充满容器 */
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 60%;
                    height: 20px;
                    /* 添加图片（替换为你的图片路径） */
                    background-image: url('../../../assets/imgs/Kingdoms/component/sign_in.png');
                    background-size: cover;
                    /* 图片自适应容器 */
                    background-position: center;
                    /* 图片居中显示 */
                    z-index: 1;
                    /* 图片层级低于文字 */
                }

                .yetitem span {
                    /* 绝对定位使文字脱离文档流 */
                    position: absolute;
                    top: 3px;
                    left: 10px;
                    /* 垂直居中 */
                    z-index: 2;
                    /* 文字层级高于图片 */
                    /* 可选：添加文字阴影增强可读性 */
                    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
                }
            }

            // end


        }
    }
}
</style>